import { createContext, useState } from "react";
import { PopOverContext } from "./types";
import PopupNotes from "../component/popupNotes";

export const PopupContext = createContext<PopOverContext | null>(null);

type Props = {
    children: any;
    onConfirm?: (params: any) => any;
    onCancel?: () => void;
}

const PopupProvider = ({children, onCancel, onConfirm}: Props) => {
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [showPopup, setShowPopup] = useState(false)

    return <PopupContext.Provider
                value={{
                    title,
                    setTitle,
                    subtitle,
                    setSubtitle,
                    showPopup,
                    setShowPopup,
                    onCancel,
                    onConfirm
                }}
    >
        {showPopup && 
            <PopupNotes
                title={title}
                subtitle={subtitle}
                showPopup={showPopup}
                setShowPopup={setShowPopup}
                onCancel={onCancel}
                onConfirm={onConfirm}
                />
            }
        {children}
    </PopupContext.Provider>
}

export default PopupProvider;